<template>
  <div class="page-content">
    <!-- 导航条 -->
    <!-- 头部区域 -->
    <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
      <div class="max-w-5xl mx-auto text-center">
        <h1 class="text-4xl md:text-5xl font-bold mb-6">产业图谱</h1>
        <div class="text-lg text-white/90 max-w-3xl mx-auto">
          <p>可视化呈现产业链全景，洞察行业发展趋势，助力决策分析</p>
        </div>
      </div>
    </header>
    <div class="max-w-1920 mx-auto px-4 py-6">
      <!-- 顶部Tab导航 -->
      <div class="mb-8">
        <div class="flex border-b border-gray-200">
          <button @click="tabSelect(1)" :class="{'tab-active':tabSelected ===1}" class="px-6 py-3 font-medium text-lg border-b-2 rounded-t-lg">
            会展城市经济发展报告
          </button>
          <button @click="tabSelect(2)" :class="{'tab-active':tabSelected ===2}" class="px-6 py-3 font-medium text-lg text-gray-600 border-b-2 border-transparent hover:text-primary transition-colors">
            策展报告
          </button>
          <button class="px-6 py-3 font-medium text-lg text-gray-600 border-b-2 border-transparent hover:text-primary transition-colors">
            专项报告
          </button>
        </div>
      </div>

      <!-- 城市选择区 -->
      <div class="mb-8" v-show="tabSelected===1">
        <div class="flex items-center">
          <span class="text-lg font-medium mr-4">城市选择：</span>
          <div class="relative">
            <select class="appearance-none bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:ring-2 focus:ring-primary/50">
              <option selected>天津</option>
              <option>北京</option>
              <option>上海</option>
              <option>广州</option>
              <option>深圳</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <i class="fas fa-chevron-down text-xs"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 主体内容区域 -->
      <div class="bg-white rounded-xl p-8 shadow-sm mb-8"  v-show="tabSelected===1">
        <h1 class="text-[clamp(1.75rem,3vw,2.5rem)] font-bold text-gradient mb-6">天津优势产业分析报告</h1>

        <p class="text-gray-600 mb-8 leading-relaxed">
          天津作为中国北方重要的经济中心和制造业基地，近年来在产业结构调整和转型升级方面取得显著成效。本报告对天津的优势产业进行全面分析，包括产业结构、主要产业产值、增长趋势等方面，为会展活动的策划和实施提供参考依据。
        </p>

        <!-- 产业结构占比饼图 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-chart-pie text-primary mr-3"></i>
            天津产业结构占比
          </h2>
          <div class="chart-container">
            <canvas id="industryStructureChart"></canvas>
          </div>
        </div>

        <!-- 主要产业产值柱状图 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-chart-bar text-primary mr-3"></i>
            天津主要产业产值(亿元)
          </h2>
          <div class="chart-container">
            <canvas id="industryOutputChart" style="height: 288px;"></canvas>
          </div>
        </div>

        <!-- 产业增长趋势折线图 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-chart-line text-primary mr-3"></i>
            天津产业增长趋势(2020-2024)
          </h2>
          <div class="chart-container">
            <canvas id="industryGrowthChart" style="height: 288px;"></canvas>
          </div>
        </div>

        <div class="section-divider"></div>

        <!-- 优势主导产业 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-award text-primary mr-3"></i>
            优势主导产业
          </h2>
          <div class="bg-primary-light/30 p-6 rounded-lg">
            <div class="flex flex-wrap gap-3">
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">中药</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">信息安全</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">办公设备</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">纺织服装</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">日用化工</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">自行车</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">文体休闲用品</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">钢铁及钢铁材料</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">生物医药</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">半导体新材料</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">医疗器械</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">医疗</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">氢能</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">化学药</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">动力电池</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">海洋工程装备</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">化工新材料</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">数控机床</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">新能源汽车</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">智能制造</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">智能网联汽车</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">机器人</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">轨道交通装备</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">航空装备</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">航天卫星</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">石化</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">精细化工</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">集成电路</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">智能终端</span>
              <span class="bg-white px-4 py-2 rounded-full text-primary font-medium text-sm shadow-sm">软件服务</span>
            </div>
          </div>
        </div>

        <!-- 引导不再承接产业 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-ban text-red-500 mr-3"></i>
            引导不再承接产业
          </h2>
          <div class="bg-red-50 p-6 rounded-lg">
            <div class="flex flex-wrap gap-3">
              <span class="bg-white px-4 py-2 rounded-full text-red-500 font-medium text-sm shadow-sm">农副产品加工</span>
              <span class="bg-white px-4 py-2 rounded-full text-red-500 font-medium text-sm shadow-sm">化学药</span>
            </div>
          </div>
        </div>

        <!-- 引导逐步退出产业 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-6 flex items-center">
            <i class="fas fa-sign-out-alt text-orange-500 mr-3"></i>
            引导逐步退出产业
          </h2>
          <div class="bg-orange-50 p-6 rounded-lg">
            <div class="flex flex-wrap gap-3">
              <span class="bg-white px-4 py-2 rounded-full text-orange-500 font-medium text-sm shadow-sm">冶金铸造</span>
              <span class="bg-white px-4 py-2 rounded-full text-orange-500 font-medium text-sm shadow-sm">有色金属矿产</span>
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <!-- 产业详细描述 -->
        <div class="mb-12">
          <h2 class="text-2xl font-bold mb-8">产业发展重点方向</h2>

          <!-- 传统产业优化 -->
          <div class="mb-8 bg-white border border-gray-200 rounded-xl p-6 card-shadow">
            <h3 class="text-xl font-bold mb-4 text-primary">传统产业优化</h3>
            <p class="text-gray-600 leading-relaxed">
              推动冶金、轻纺等传统产业高端化、绿色化、智能化升级，打造高技术含量、高附加值产品。通过技术改造和创新，提升传统产业的竞争力和可持续发展能力，实现传统产业的凤凰涅槃。
            </p>
          </div>

          <!-- 新兴产业培育 -->
          <div class="mb-8 bg-white border border-gray-200 rounded-xl p-6 card-shadow">
            <h3 class="text-xl font-bold mb-4 text-primary">新兴产业培育</h3>
            <p class="text-gray-600 leading-relaxed">
              重点发展生物医药、高端医疗器械、智慧医疗与大健康、新能源、新材料等新兴产业。通过政策支持、资金投入和人才引进，培育壮大新兴产业集群，形成新的经济增长点。
            </p>
          </div>

          <!-- 海洋经济发展 -->
          <div class="mb-8 bg-white border border-gray-200 rounded-xl p-6 card-shadow">
            <h3 class="text-xl font-bold mb-4 text-primary">海洋经济发展</h3>
            <p class="text-gray-600 leading-relaxed">
              构建海洋工程装备制造产业链，重点发展海洋油气装备、船舶装备、港口航道工程装备、海水淡化成套装备等四大产业集群。充分发挥天津的海洋资源优势，打造具有国际竞争力的海洋经济示范区。
            </p>
          </div>

          <!-- 装备制造业提升 -->
          <div class="mb-8 bg-white border border-gray-200 rounded-xl p-6 card-shadow">
            <h3 class="text-xl font-bold mb-4 text-primary">装备制造业提升</h3>
            <p class="text-gray-600 leading-relaxed">
              提升智能装备、轨道交通装备、海洋装备，高档数控机床、工业机器人等装备制造业的技术水平和市场竞争力。通过自主创新和产学研合作，突破关键核心技术，实现装备制造业的高端化发展。
            </p>
          </div>

          <!-- 信息产业发展 -->
          <div class="bg-white border border-gray-200 rounded-xl p-6 card-shadow">
            <h3 class="text-xl font-bold mb-4 text-primary">信息产业发展</h3>
            <p class="text-gray-600 leading-relaxed">
              大力发展集成电路、基础软件、应用软件、终端设备、网络安全等信息产业。加强信息基础设施建设，推动信息技术与实体经济深度融合，促进数字经济发展，打造"数字天津"。
            </p>
          </div>
        </div>
      </div>

      <img v-if="tabSelected===2" class="img-div" src="../assets/images/industry/ssssss1.png"/>
    </div>
  </div>
</template>
<script>
/* global Chart */

// eslint-disable-next-line no-undef
tailwind.config = {
  theme: {
    extend: {
      colors: {
        primary: '#2563EB',
        secondary: '#204E9C',
        background: '#F9FAFB',
        'primary-light': '#DBEAFE',
        'secondary-light': '#BFDBFE',
      },
      fontFamily: {
        sans: ['Inter', 'system-ui', 'sans-serif'],
      },
      maxWidth: {
        '1920': '1920px',
      },
    },
  }
}

export default {
  name: "MeetingReport",
  data(){
    return{
      tabSelected: 1
    }
  },
  mounted () {
    // 产业结构占比饼图
    const industryStructureCtx = document.getElementById('industryStructureChart').getContext('2d');
    new Chart(industryStructureCtx, {
      type: 'pie',
      data: {
        labels: ['装备制造业', '电子信息产业', '生物医药', '新能源新材料', '化工产业', '冶金产业', '其他产业'],
        datasets: [{
          data: [28, 22, 15, 12, 10, 8, 5],
          backgroundColor: [
            '#2563EB',
            '#3B82F6',
            '#60A5FA',
            '#93C5FD',
            '#BFDBFE',
            '#DBEAFE',
            '#EFF6FF'
          ],
          borderWidth: 0,
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              padding: 20,
              font: {
                size: 12
              }
            }
          },
          title: {
            display: true,
            text: '天津各产业占比分布',
            font: {
              size: 16,
              weight: 'bold'
            },
            padding: {
              bottom: 20
            }
          }
        }
      }
    });

    // 主要产业产值柱状图
    const industryOutputCtx = document.getElementById('industryOutputChart').getContext('2d');
    new Chart(industryOutputCtx, {
      type: 'bar',
      data: {
        labels: ['装备制造业', '电子信息产业', '生物医药', '新能源新材料', '化工产业', '冶金产业', '海洋工程装备'],
        datasets: [{
          label: '产业产值(亿元)',
          data: [3200, 2600, 1800, 1400, 1200, 900, 700],
          backgroundColor: '#2563EB',
          borderRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: '2024年天津主要产业产值统计',
            font: {
              size: 16,
              weight: 'bold'
            },
            padding: {
              bottom: 20
            }
          }
        }
      }
    });

    // 产业增长趋势折线图
    const industryGrowthCtx = document.getElementById('industryGrowthChart').getContext('2d');
    new Chart(industryGrowthCtx, {
      type: 'line',
      data: {
        labels: ['2020', '2021', '2022', '2023', '2024'],
        datasets: [
          {
            label: '装备制造业',
            data: [2400, 2600, 2800, 3000, 3200],
            borderColor: '#2563EB',
            backgroundColor: 'rgba(37, 99, 235, 0.1)',
            tension: 0.3,
            fill: true
          },
          {
            label: '电子信息产业',
            data: [1800, 2000, 2200, 2400, 2600],
            borderColor: '#204E9C',
            backgroundColor: 'rgba(32, 78, 156, 0.1)',
            tension: 0.3,
            fill: true
          },
          {
            label: '生物医药',
            data: [1200, 1400, 1500, 1650, 1800],
            borderColor: '#60A5FA',
            backgroundColor: 'rgba(96, 165, 250, 0.1)',
            tension: 0.3,
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              usePointStyle: true,
              boxWidth: 6
            }
          },
          title: {
            display: true,
            text: '天津重点产业产值增长趋势',
            font: {
              size: 16,
              weight: 'bold'
            },
            padding: {
              bottom: 20
            }
          }
        }
      }
    });
  },
  methods: {
    tabSelect(tab){
      this.tabSelected = tab
    }
  }
}
</script>

<style scoped>
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
  overflow-x: hidden;
}

.img-div{
  width: 1260px;
}

.tab-active {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
  margin-top: 20px;
}

. @layer utilities {
  .content-auto {
    content-visibility: auto;
  }
  .tab-active {
    @apply bg-primary text-white border-primary;
  }
  .card-shadow {
    @apply shadow-md hover:shadow-lg transition-shadow duration-300;
  }
  .text-gradient {
    @apply bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary;
  }
  .chart-container {
    @apply h-[400px] w-full relative;
  }
  .section-divider {
    @apply border-t border-gray-200 my-8;
  }
}
</style>
